module.exports = __webpack_public_path__ + "img/4f6f6f316cde4398d201cd67e44ddea3.4f6f6f31.svg";